module.exports = __webpack_public_path__ + "static/phase_spider-7eecf2ca2a103b9f0efd006faebaeac8.webp";